import { Directive } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[rtTypeaheadInput]',
  exportAs: 'rtTypeaheadInput',
})
export class TypeaheadInputDirective {
  constructor(public control: NgControl) {}
}
